export function searchDataArray() {
  const courtArray = [
    "臺灣台北地方法院",
    "臺灣新北地方法院",
    "臺灣士林地方法院",
    "臺灣桃園地方法院",
    "臺灣新竹地方法院",
    "臺灣苗栗地方法院",
    "臺灣臺中地方法院",
    "臺灣南投地方法院",
    "臺灣彰化地方法院",
    "臺灣雲林地方法院",
    "臺灣嘉義地方法院",
    "臺灣臺南地方法院",
    "臺灣橋頭地方法院",
    "臺灣高雄地方法院",
    "臺灣屏東地方法院",
    "臺灣臺東地方法院",
    "臺灣花蓮地方法院",
    "臺灣宜蘭地方法院",
    "臺灣基隆地方法院",
    "臺灣澎湖地方法院",
    "福建金門地方法院",
    "福建連江地方法院",
  ];

  const pageAmountArray = [
    "1筆",
    "2筆",
    "3筆",
    "4筆",
    "5筆",
    "6筆",
    "7筆",
    "8筆",
    "9筆",
    "10筆",
  ];

  // const typeLand = [
  //   "土地",
  //   "建物",
  //   "田地",
  //   "旱地",
  //   "林地",
  //   "原住民",
  //   "道路用地",
  //   "透天",
  //   "樓店",
  //   "廠房",
  //   "平房",
  //   "地下室",
  //   "華廈",
  //   "公寓",
  //   "套房",
  //   "辦公",
  //   "含車位",
  // ];
  const typeLand = [
    "透天",
    "樓店",
    "廠房",
    "平房",
    "地下室",
    "華廈",
    "公寓",
    "套房",
    "辦公",
    "含車位",
    "其他",
  ];
  const BuyTypeLand = [
    "透天",
    "樓店",
    "廠房",
    "平房",
    "地下室",
    "華廈",
    "公寓",
    "套房",
    "辦公",
    "含車位",
  ];

  const auctionsArray = [
    "1拍",
    "2拍",
    "3拍",
    "應買",
    "4拍",
    "5拍",
    "6拍",
    "7拍",
    "8拍",
    "9拍",
    "10拍",
  ];

  const typeArray = ["土地", "建物"];

  const landRightsArray = ["不分", "全部", "持分"];

  const buildRightsArray = ["不分", "全部", "持分"];

  const pointHandArray = ["不分", "點交", "不點交", "其他"];

  const sourceOfTheCaseArray = [
    "不分",
    "司法院",
    "台灣金服",
    "榮服處",
    "國有財務局",
    "台灣糖業",
  ];

  return {
    courtArray,
    pageAmountArray,
    typeLand,
    BuyTypeLand,
    auctionsArray,
    landRightsArray,
    buildRightsArray,
    pointHandArray,
    sourceOfTheCaseArray,
    typeArray,
  };
}
